<template>
	<div>
		<v-text-field
			browser-autocomplete="off"
			label="label pola"
			aria-label="label"
			for="number-field-props-label"
			id="number-field-props-label"
			v-model="fieldProps.label"
			class="text-xs-center"
			outline>
		</v-text-field>
		<v-text-field
			browser-autocomplete="off"
			label="hint"
			aria-label="hint"
			for="number-field-props-hint"
			id="number-field-props-hint"
			v-model="fieldProps.hint"
			class="text-xs-center"
			outline>
		</v-text-field>
		<v-text-field
			browser-autocomplete="off"
			label="Minimalna wartość"
			aria-label="min value"
			for="number-field-props-min-value"
			id="number-field-props-min-value"
			v-model="fieldProps.min"
			type="number"
			class="text-xs-center"
			outline>
		</v-text-field>
		<v-text-field
			browser-autocomplete="off"
			label="Maksymalna wartość"
			aria-label="max value"
			for="number-field-props-max-value"
			id="number-field-props-max-value"
			v-model="fieldProps.max"
			type="number"
			v
			class="text-xs-center"
			outline>
		</v-text-field>
		<v-checkbox v-model="fieldProps.required" :label="`Wymagane`" aria-label="mandatory"></v-checkbox>
		<v-checkbox v-model="fieldProps.view" :label="`Wyświetlanie na podglądzie`"
			aria-label="show on print view"></v-checkbox>
	</div>
</template>

<script>
	export default {
		name: "numberFieldProps",

		watch: {
			fieldProps: {
				handler() {
					this.$emit("input", this.fieldProps);
				},
				deep: true,
			},
		},

		props: {
			value: Object,
		},

		data() {
			return {
				fieldProps: this.value,
			};
		},
	};
</script>

<style scoped>

</style>
